import { EntityEditFormModal } from '../../Entity'

import { QA_NAME_CALENDAR_RELIEVE_DAY_MODAL } from './CalendarRelieveDayModal.constants'
import { getCalendarRelieveDayPayload } from './CalendarRelieveDayModal.utils'
import { CalendarRelieveDayModalActions } from './CalendarRelieveDayModalActions'
import { CalendarRelieveDayModalBody } from './CalendarRelieveDayModalBody'
import { CalendarRelieveDayModalFields } from './CalendarRelieveDayModalFields'

function CalendarRelieveDayModal({
  day,
  dayLoad,
  followUps,
  nextFreeDay,
  onSubmit,
  ...restProps
}) {
  function handleSubmit(params) {
    onSubmit({ ...params, day })
  }

  return (
    <EntityEditFormModal
      {...restProps}
      Fields={CalendarRelieveDayModalFields}
      FormBody={CalendarRelieveDayModalBody}
      formBodyProps={{
        Actions: CalendarRelieveDayModalActions,
        actionsProps: { day },
        submitButtonText: 'Calendar.RelieveDaySubmitKey',
      }}
      formFieldsProps={{ day, dayLoad, followUps, nextFreeDay }}
      formTitle='Calendar.RelieveDayKey'
      getPayload={getCalendarRelieveDayPayload}
      qaName={QA_NAME_CALENDAR_RELIEVE_DAY_MODAL}
      onSubmit={handleSubmit}
    />
  )
}

export default CalendarRelieveDayModal
